export default __webpack_public_path__ + "static/media/Adulting101.da52e8a2.png";